<template>
  <div>

    <text-field
      :data="data"
      name="contactName"
      :label="label.contactName"
      :helpText="helpText.contactName"
      kind='input'
      inputType='text'
      :required=true
      placeholder='Petr Novák'
      @updated="updatedName"
    ></text-field>

    <text-field
      :data="data"
      name="phone"
      :label="label.phone"
      :helpText="helpText.phone"
      kind='input'
      inputType='phone'
      :required=true
      placeholder='123 456 789'
      @updated="formUpdated"
    ></text-field>

    <div v-if="isForCompany">
      <text-field
        :data="data.company"
        name="ic"
        label='IČO'
        :required=true
        kind='input'
        inputType='text'
        placeholder='CZ 123 45 678'
        @updated="formUpdated"
      ></text-field>

      <text-field
        :data="data.company"
        name="name"
        label='Název společnosti'
        :required=true
        kind='input'
        inputType='text'
        placeholder='Voňavá s.r.o.'
        @updated="formUpdated"
      ></text-field>
    </div>

    <text-field
      :data="data"
      name='address'
      :label="label.address"
      :helpText="helpText.address"
      :required=true
      kind='googlemaps-autocomplete'
      :restrictAddress="restrictAddress"
      inputType='text'
      @updated="formUpdated"
    ></text-field>

    <text-field
      v-if="isForCompany == true"
      :data="data"
      name="note"
      label='Poznámka na fakturu'
      kind='input'
      inputType='text'
      placeholder='Kytice pro šéfovou'
      @updated="formUpdated"
    ></text-field>

  </div>
</template>

<script>
import Cart from '@/cart';
import Lang from '@/langs';

// import GoogleMapsAutocomplete from '@/components/common/GoogleMapsAutocomplete'

import Notification from '@/notification'
import Validator from '@/service/Validator'
import TextField from '@/components/common/TextField'

import CountrySelect from './CountrySelect'

export default {
  props: ['data', 'name', 'isForCompany', 'same'],
  components: {
    CountrySelect,
    // GoogleMapsAutocomplete,
    TextField
  },
  data () {
    return {
      Cart: Cart,
      contactName: '',
      Validator: Validator,
      Lang: Lang,
      google: null,
      googleReady: false,
      autocomplete: null,
      company: false,
      restrictAddress: null,
      // isForCompany: Cart.data.delivery.billing.forCompany,
      deliveryParams: Cart.data.delivery.billing,
      address: '',
      label: {
        contactName: null,
        phone: null,
        address: null
      },
      helpText: {
        contactName: null,
        phone: null,
        address: null
      }
    };
  },
  watch: {
    deliveryParams: {
      deep: true,
      handler() {
        console.log('Updated delivery params')
        // this.isForCompany = Cart.data.delivery.billing.forCompany
        if (this.isForCompany == false) {
          this.data.company.ic = ''
          this.data.company.name = ''
        }
      }
    },
    same: {
      handler() {
        console.log('ContactBilling toggled same', this.same)
        this.setLabels()
      }
    }
  },
  created() {
    this.updateAddressRestriction()
    
    console.log('Contact::created', this.name, this.data, Cart.data.delivery)
    this.setLabels()
    let n = this.data.firstName ? this.data.firstName : ''
    n = n + ((n != '' && this.data.surname) ? ' ' : '')
    n = n + (this.data.surname ? this.data.surname : '')
    this.contactName = n

    this.address = this.getAddress()
  },
  methods: {
    updateAddressRestriction() {
      if (Cart.data.delivery.code.match(/BRANCH/)) {
        console.log('ContactBilling: restrictAddress changed to: false')
        this.restrictAddress = false
      } else {
        console.log('ContactBilling: restrictAddress changed to: same as shippingIsSame')
        this.restrictAddress = this.data.shippingIsSame
      }
    },
    setLabels() {
      if (this.same) {
        this.label = {
          contactName: 'Jméno a příjmení',
          phone: 'Telefon',
          address: 'Adresa'
        }
        this.helpText = {
          contactName: 'Jméno osoby, která bude přebírat objednávku.',
          phone: 'Telefon osoby, která bude přebírat objednávku. Bude na něj volat doručovatel.',
          address: 'Sem Tvoji objednávku doručíme.'
        }
      } else {
        this.label = {
          contactName: 'Jméno a příjmení',
          phone: 'Telefon',
          address: 'Adresa'
        }
        this.helpText = {
          contactName: null,
          phone: null,
          address: null
        }
      }
    },
    validate(cb) {
      this.$validator.validateAll()
      .then(res => {
        if(!res) {
            Notification.add('err', 'Prosím, opravte své údaje', 15)
            cb(false)
        }
        cb(true)
      })
    },
    getAddress() {
      let addObj = this.data.address
      if (addObj) {
        let address = []
        this.pushOrNot(address, addObj.route)
        this.pushOrNot(address, addObj.street_number)
        this.pushOrNot(address, addObj.administrative_area_level_1)
        this.pushOrNot(address, addObj.administrative_area_level_2)
        this.pushOrNot(address, addObj.postal_code)
        this.pushOrNot(address, addObj.country)
    
        console.log('Showing the address', address, address.join(', '))
        return address.join(', ')
      } else {
        return ''
      }
    },
    pushOrNot(arr, val) {
      if (val) {
        arr.push(val)
      }
    },
    updatedName(context) {
      console.log('Updated name', context)
      if (context === undefined) {
        return
      }
      let nChungs = context != '' ? context.split(' ') : []
      this.data.firstName = nChungs.length > 0 ? nChungs.splice(0,1)[0] : ''
      this.data.surname = nChungs.length > 0 ? nChungs.join(' ') : ''
      this.formUpdated()
    },
    formUpdated() {
      this.$emit('updated', {calculate: false});
    },
    getAddressData(address, place) {
      let country = place.address_components.find(cmp => {return cmp.types.indexOf('country') > -1})
      console.log('New address found', address, place, country)
      this.data.address = address
      if (country) {
        this.data.address.countryShort = country.short_name
      }
      this.formUpdated()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
</style>
